<template>
  <div class="form-add">
    <validation-observer ref="simpleRules">
      <b-form>
        <div class="form-add-nav p-2 mt-1">
          {{ i18n('form.tab.personal') }}
        </div>
        <b-row class="form-add-body p-2">
          <b-col
            v-for="(col, col_i) in columnsPersonal"
            :key="col.field || col_i"
            :md="col.span || 4"
          >
            <b-form-group :label-for="`v-add-${col.field}`">
              <my-tooltip :tooltip="col.SearchTooltip" show-icon>
                <label :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                >
              </my-tooltip>
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <div v-if="col.field === 'mobile'">
                  <el-input
                    placeholder="Mobile"
                    v-model="form.mobile"
                    type="number"
                  >
                    <el-select
                      style="width: 90px"
                      v-model="form.mobileCode"
                      slot="prepend"
                      filterable
                      :filter-method="customFilter"
                    >
                      <el-option
                        v-for="country in filteredCountries"
                        :key="country.code"
                        :label="country.nameLabel"
                        :value="country.zone"
                      >
                      </el-option>
                    </el-select>
                  </el-input>
                </div>
                <div v-else>
                  <element-component
                    v-if="!col.hide"
                    :id="`v-add-${col.field}`"
                    v-model="form[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :disabled="col.disabled"
                    :option="col"
                  />
                </div>

                <template v-if="col.disabled">
                  <small class="text-primary">{{ col.small }}</small>
                </template>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="form-add-line" />
        <div class="form-add-nav p-2 mt-1">
          {{ i18n('form.tab.employment') }}
        </div>

        <b-row class="form-add-body p-2">
          <b-col
            v-for="(col, col_i) in columnsEmployment"
            :key="col.field || col_i"
            :md="col.span || 4"
          >
            <b-form-group :label-for="`v-add-${col.field}`">
              <my-tooltip :tooltip="col.SearchTooltip" show-icon>
                <label :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                >
              </my-tooltip>
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <element-component
                  :id="`v-add-${col.field}`"
                  v-model="form[col.field]"
                  :state="errors.length > 0 ? false : null"
                  :label="col.label"
                  :disabled="col.disabled"
                  :option="col"
                />
                <template v-if="col.disabled">
                  <small class="text-primary">{{ col.small }}</small>
                </template>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- submit and reset -->
        <div class="form-add-nav p-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click.prevent="validationForm"
          >
            {{ $t('_components.btns.save') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            :disabled="loading"
            @click="resetForm"
          >
            {{ $t('_components.btns.cancel') }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, confirmed, password } from '@validations'
import Ripple from 'vue-ripple-directive'
import { BCard, BCol, BRow, BFormGroup, BButton, BForm } from 'bootstrap-vue'
import ElementComponent from '@/components/elementComponent.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyTooltip from '@/components/myTooltip.vue'
import WORKER from '@/api/worker/index'
import { deepClone } from '@/util/util'
import countryCode from '@/util/mobileCode'
export default {
  name: 'FormAdd',
  components: {
    // BCard,
    ElementComponent,
    BCol,
    BRow,
    BFormGroup,
    MyTooltip,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
  },
  directives: {
    Ripple,
  },
  props: {
    defaultForm: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      // form: {},
      countries: [],
      filteredCountries: [],
      form: deepClone(this.defaultForm) || { isCreate: '2', mobileCode: '+65' },
      disabled: false,
      loading: false,
      // 规则
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
  },
  computed: {
    columnsPersonal() {
      const columnss = [
        {
          label: this.i18n('label.name'),
          field: 'name',
          searchSpan: 2,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.cnName'),
          field: 'cnName',
          searchSpan: 2,
          searchBase: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nationality'),
          field: 'nationality',
          type: 'select',
          dictCode: 'nationality',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.personalEmail'),
          field: 'personalEmail',
          formOption: {
            rules: 'required|email',
          },
        },
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          type: 'select',
          searchSpan: 2,
          dictBizCode: 'gender',
          dicName: 'sexName',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.employmentCategory'),
          field: 'employmentCategory',
          type: 'select',
          dictBizCode: 'worker_employment_category',
          dicName: 'employmentCategoryName',
        },
        {
          label: this.i18n('label.employmentCode'),
          field: 'employmentCode',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.cardNo'),
          field: 'cardNo',
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.projectId'),
          field: 'projectId',
          type: 'select',
          dictCode: 'project',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.status'),
          field: 'status',
          type: 'select',
          dictBizCode: 'info_status',
        },
        {
          label: this.i18n('label.address'),
          field: 'address',
          span: 12,
        },
        // new Field
        {
          label: this.i18n('label.vaccinationStatus'),
          field: 'vaccinationStatus',
          type: 'select',
          dictBizCode: 'vaccination_status',
        },
        {
          label: this.i18n('label.religion'),
          field: 'religion',
          type: 'select',
          dictBizCode: 'religion',
        },
        {
          label: this.i18n('label.race'),
          field: 'race',
          type: 'select',
          dictBizCode: 'race',
        },
        {
          label: this.i18n('label.idType'),
          field: 'idType',
          type: 'select',
          dictBizCode: 'id_type',
        },
        {
          label: this.i18n('label.chinaCode'),
          field: 'chinaCode',
          type: 'select',
          dictBizCode: 'china_code',
        },
        {
          label: this.i18n('label.birthCountry'),
          field: 'birthCountry',
          fieldDict: 'birthCountryName',
          type: 'select',
          dictCode: 'nationality',
        },
        {
          label: this.i18n('label.birthCity'),
          field: 'birthCity',
          type: 'select',
          dictCode: 'city',
          dictQuery: {
            code: this.form.birthCountry,
          },
          disabled: !this.form.birthCountry,
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('label.birthCountry'),
        },
        // {
        //   // label: this.i18n('label.birthCountry'),
        //   label: 'CN Birth City',
        //   field: 'cnBirthCity',
        // },
        {
          label: 'Marital Status',
          field: 'maritalStatus',
          type: 'select',
          dictBizCode: 'staff_marital_status',
        },
        {
          label: 'Foreign ID',
          field: 'foreignId',
        },
        {
          label: 'Permit Type',
          field: 'permitType',
          type: 'select',
          dictBizCode: 'worker_permit_type',
        },
        {
          label: 'Levy',
          field: 'levy',
        },
        {
          label: 'FIN NO',
          field: 'fin_no',
        },
        {
          label: 'Health Status',
          field: 'healthStatus',
          type: 'select',
          dictBizCode: 'health_status',
        },
        {
          label: 'Access Code',
          field: 'accessCode',
          type: 'select',
          dictBizCode: 'access_code',
        },
        {
          label: 'Trace App',
          field: 'traceApp',
          type: 'select',
          dictBizCode: 'trace_app',
        },
        {
          label: this.i18n('label.isCreate'),
          field: 'isCreate',
          type: 'radio',
          dictBizCode: 'is_create',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: 'Photo',
          field: 'photo',
          type: 'upload',
          span: 'auto',
        },
        {
          label: 'Sign',
          field: 'sign',
          type: 'upload',
          span: 'auto',
        },
      ]

      const columns = []
      columnss.forEach((item) => {
        const params = item
        const searchObj = this.defaultForm
          ? this.defaultForm[item.field]
          : undefined
        if (searchObj) {
          params.disabled = true
        }
        columns.push(params)
      })

      return columns
    },
    columnsEmployment() {
      const columnss = [
        {
          label: this.i18n('labelEmployment.companyId'),
          field: 'companyId',
          type: 'select',
          dictBizCode: 'company',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.joinDate'),
          field: 'joinDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.email'),
          field: 'email',
          required: true,
          formOption: {
            rules: 'required|email',
          },
        },
        {
          label: this.i18n('labelEmployment.specialistId'),
          field: 'specialistId',
          type: 'select',
          dictCode: 'special',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.position'),
          field: 'position',
          type: 'select',
          dictCode: 'position',
          dictQuery: {
            specialistId: this.form.specialistId,
          },
          disabled: !this.form.specialistId,
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('labelEmployment.specialistId'),
        },
        {
          label: this.i18n('labelEmployment.workingSkill'),
          field: 'workingSkill',
          type: 'select',
          dictBizCode: 'working_skill',
        },
        {
          label: this.i18n('labelEmployment.workingAttitude'),
          field: 'workingAttitude',
          type: 'select',
          dictBizCode: 'working_attitude',
        },
        {
          label: this.i18n('labelEmployment.socExpiryDate'),
          field: 'socExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        // {
        //   label: this.i18n('labelEmployment.position'),
        //   field: 'position',
        //   type: 'select',
        //   dictBizCode: 'worker_position',
        // },
        {
          label: this.i18n('labelEmployment.skill'),
          field: 'skill',
        },
        // TODO 课程名称
        {
          label: this.i18n('labelEmployment.coreTradeReg'),
          field: 'coreTradeReg',
        },
        {
          label: this.i18n('labelEmployment.myeCertificateNo'),
          field: 'myeCertificateNo',
        },
        {
          label: this.i18n('labelEmployment.passportStatus'),
          field: 'passportStatus',
          type: 'select',
          dictBizCode: 'passport_bor_status',
          // formOption: {
          //   rules: 'required',
          // },
        },
        {
          label: this.i18n('labelEmployment.transport'),
          field: 'transport',
        },
        {
          label: this.i18n('labelEmployment.meals'),
          field: 'meals',
          type: 'select',
          dictBizCode: 'worker_meals',
        },
        {
          label: this.i18n('labelEmployment.dormitory'),
          field: 'dormitory',
        },
        {
          label: this.i18n('labelEmployment.room'),
          field: 'room',
        },
        {
          label: this.i18n('labelEmployment.bankName'),
          field: 'bankName',
        },
        {
          label: this.i18n('labelEmployment.bankCode'),
          field: 'bankCode',
        },
        {
          label: this.i18n('labelEmployment.bankAccount'),
          field: 'bankAccount',
        },
        {
          label: this.i18n('labelEmployment.bankNumber'),
          field: 'bankNumber',
        },
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.wpLastUpdateDate'),
          field: 'wpLastUpdateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.wpResignationDate'),
          field: 'wpResignationDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.issueDate'),
          field: 'issueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.applicateDate'),
          field: 'applicateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          // label: this.i18n('labelEmployment.myeCertificateNo'),
          label: 'CPF A/C',
          field: 'cpfId',
        },
        {
          // label: this.i18n('labelEmployment.myeCertificateNo'),
          label: 'Business Section',
          field: 'businessSection',
          type: 'select',
          dictBizCode: 'worker_business_section',
        },
        {
          // label: this.i18n('labelEmployment.myeCertificateNo'),
          label: 'Level',
          field: 'level',
          type: 'select',
          dictBizCode: 'worker_level',
        },
        {
          // label: this.i18n('labelEmployment.myeCertificateNo'),
          label: 'Rest Day',
          field: 'restDay',
          type: 'select',
          dictBizCode: 'rest_day',
        },
        {
          label: 'Rest Remark',
          field: 'restRemark',
        },
        {
          label: 'Operation Remark ',
          field: 'operationRemark',
        },
        {
          label: this.i18n('labelEmployment.jobTitle'),
          field: 'jobTitle',
          type: 'select',
          dictBizCode: 'jobTitle',
        },
      ]

      const columns = []
      columnss.forEach((item) => {
        const params = item
        const searchObj = this.defaultForm
          ? this.defaultForm[item.field]
          : undefined
        if (searchObj) {
          params.disabled = true
        }
        columns.push(params)
      })

      return columns
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // this.$emit('submit', this.form)
          const form = deepClone(this.form)
          form.mobile = `${form.mobileCode} ${form.mobile}`
          // form.isCreate = 1
          form.photo =
            form.photo &&
            form.photo.length &&
            form.photo.map((o) => o.attachId).join()
          form.sign =
            form.sign &&
            form.sign.length &&
            form.sign.map((o) => o.attachId).join()
          WORKER.addList(form).then((res) => {
            this.$emit('submit', this.form)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
          })
        }
      })
    },
    resetForm() {
      this.form = {
        mobileCode: '+65',
      }
      this.$emit('closeForm')
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form/index.scss';
.form-add {
  &-nav {
    font-size: 20px;
    font-weight: 400;
    color: #13419d;
    line-height: 28px;
    overflow-x: hidden;
  }
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
  }
  &-body {
    box-sizing: border-box;
  }
}
</style>
